import { useEffect, useRef } from "react";

export interface InAppNotification {
  id: string;
  type: string;
  title: string;
  body: string;
  ctaUrl: string | null;
  ctaLabel: string | null;
  createdAt: string;
}

/**
 * Connecte un EventSource à /api/notifications/stream et invoque onNotification
 * à chaque nouvel événement push. Reconnect auto via le retry SSE natif.
 *
 * Le cookie httpOnly d'auth est transmis automatiquement par le navigateur
 * (même origine, withCredentials par défaut sur les EventSource same-origin).
 */
export function useNotificationStream(
  enabled: boolean,
  onNotification: (notif: InAppNotification) => void,
): void {
  const callbackRef = useRef(onNotification);
  callbackRef.current = onNotification;

  useEffect(() => {
    if (!enabled) return;

    const es = new EventSource("/api/notifications/stream");

    const handler = (ev: MessageEvent) => {
      try {
        const notif = JSON.parse(ev.data) as InAppNotification;
        callbackRef.current(notif);
      } catch {
        // payload invalide — ignore
      }
    };

    es.addEventListener("notification", handler as EventListener);

    return () => {
      es.removeEventListener("notification", handler as EventListener);
      es.close();
    };
  }, [enabled]);
}
